export type RecorderStatus = "idle" | "requesting" | "recording" | "recorded" | "denied" | "unsupported";

export interface RecorderState {
  status: RecorderStatus;
  elapsedSeconds: number;
}

export type RecorderEvent =
  | { type: "request" }
  | { type: "granted" }
  | { type: "denied" }
  | { type: "unsupported" }
  | { type: "tick"; elapsedSeconds: number }
  | { type: "stopped" }
  | { type: "reset" };

export const initialRecorderState: RecorderState = { status: "idle", elapsedSeconds: 0 };

export function recorderReducer(state: RecorderState, event: RecorderEvent): RecorderState {
  switch (event.type) {
    case "request":
      return state.status === "idle" || state.status === "denied"
        ? { status: "requesting", elapsedSeconds: 0 }
        : state;
    case "granted":
      return state.status === "requesting" ? { status: "recording", elapsedSeconds: 0 } : state;
    case "denied":
      return state.status === "requesting" ? { status: "denied", elapsedSeconds: 0 } : state;
    case "unsupported":
      return { status: "unsupported", elapsedSeconds: 0 };
    case "tick":
      return state.status === "recording" ? { ...state, elapsedSeconds: event.elapsedSeconds } : state;
    case "stopped":
      return state.status === "recording" ? { ...state, status: "recorded" } : state;
    case "reset":
      return state.status === "unsupported" ? state : initialRecorderState;
  }
}

export function shouldAutoStop(state: RecorderState, maxSeconds: number): boolean {
  return state.status === "recording" && state.elapsedSeconds >= maxSeconds;
}
